module.exports = __webpack_public_path__ + "static/img/title-bh.2b8524d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/title-bh.png
// module id = PgMW
// module chunks = 41